












import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import DefaultLayout from "./components/layouts/_DefaultLayout.vue";
import ConsentLayout from "./components/layouts/_ConsentLayout.vue";
import BasicLayout from "./components/layouts/_BasicLayout.vue";
import AutoLogout from "./components/common/AutoLogout.vue";
import { bus } from "@/bus";
import store from "./store/index";
import { setUpResponseInterceptors } from "@/services/interceptors";
import "@/assets/style/main.scss";
import {
    getInstanceName,
    getLogLevels
} from "./services/applicationSettings/applicationSettingsService";
import { hasUserConsented } from "./services/security/authService";
import { LoadCustomWebFonts } from "./services/fonts/fontsService";
import moment from "moment";
import i18n from "./i18n";

@Component({
    components: {
        "default-layout": DefaultLayout,
        "basic-layout": BasicLayout,
        "auto-logout": AutoLogout,
        "consent-layout": ConsentLayout
    }
})
export default class App extends Vue {
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    @Action("loadAzureAdStatus") loadAzureAdStatus: any;
    @Action("logger/updateLogLevels") updateLogLevels: any;
    @Action("logger/shipLogs") shipLogs: any;
    hasConsented = true;

    get layout() {
        const isloggedIn: boolean = store.getters["authentication/isLoggedIn"];
        if (isloggedIn) {
            if (!this.hasConsented) {
                return "consent-layout";
            }
            this.$appInsights.setAuthenticatedUserContext(store.getters["authentication/getCurrentUser"].id);
            return this.$route.meta.layout || "default-layout";
        } else {
            return "basic-layout";
        }
    }

    instanceName = "";

    @Watch("$route", { deep: true }) routeChanged() {
        this.setTitle();
    }

    public created(): void {
        this.loadAzureAdStatus();
        this.initLogging();
        setUpResponseInterceptors();
        LoadCustomWebFonts();
        getInstanceName().then((response: string) => {
            this.instanceName = response;
            this.setTitle();
        });

        // When the title has to be something dynamic.
        bus.$on("documentTitle", (name: string) => {
            document.title = `${this.instanceName} - ${name}`;
        });
        bus.$on("consentLayout", (consent: boolean) => {
            this.hasConsented = consent;
        });
        const isloggedIn: boolean = store.getters["authentication/isLoggedIn"];
        if (isloggedIn && !this.getCurrentUser.isImpersonated) {
            hasUserConsented(store.getters["authentication/getCurrentUser"].id).then(response => {
                this.hasConsented = response;
            });
        }

        const currentLocale = i18n.locale;
        // Moment's Swedish language code is "SV"
        const momentLocale = currentLocale === "se" ? "sv" : currentLocale;
        moment.locale(momentLocale);
    }

    initLogging() {
        getLogLevels().then(response => {
            if (!response || response === "") {
                return;
            }

            this.updateLogLevels(response);
        });

        setInterval(this.shipLogs, 20000);
    }

    // Set the page title. These are set inside the router meta as a title prop.
    setTitle() {
        const title = this.$route.meta.title;
        if (title !== undefined) document.title = `${this.instanceName} - ${this.$t(title)}`;
    }
}
